module.exports = __webpack_public_path__ + "static/media/painpoint.1708a857.gif";